<h3 mat-dialog-title>Do you really want to clear this checklist item?</h3>
<div mat-dialog-content *ngIf="taskItemData.status !=1">
      <h4>Issue Found: {{taskData.comment}}</h4>
      <h4>Corrective Action: {{taskData.correctiveAction}}</h4>
      <h4>Name: {{taskData.tagno}}</h4>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="submitClear()">Clear</button>
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
</div>